{
  "version": 1,
  "asset_id": "cb4b7617-29c7-4689-a945-c7ad29fd290c",
  "project_id": "39db9d3d-7b53-4499-b84e-1b89accf167e",
  "url": "/__l5e/assets-v1/cb4b7617-29c7-4689-a945-c7ad29fd290c/adapted-wordmark-light.webp",
  "r2_key": "a/v1/39db9d3d-7b53-4499-b84e-1b89accf167e/cb4b7617-29c7-4689-a945-c7ad29fd290c/adapted-wordmark-light.webp",
  "original_filename": "adapted-wordmark-light.webp",
  "size": 12950,
  "content_type": "image/webp",
  "created_at": "2026-08-18T08:34:45Z"
}
